/* eslint-disable no-unused-vars */
import {
    useElement,
    useState,
    useStaleLayout,
    useRect,
    useEffect,
    useModel,
  } from '@nebula.js/stardust';
  import picassojs from 'picasso.js';
  import numeral from 'numeral';
  import picassoQ from 'picasso-plugin-q';
  import picassoHammer from 'picasso-plugin-hammer';
  import * as d3 from 'd3';

  export default function supernova() {
    const picasso = picassojs();
    picasso.use(picassoQ);
    picasso.use(picassoHammer);

    return {
      qae: {
        properties: {
          qHyperCubeDef: {
            qDimensions: [],
            qMeasures: [],
            qInitialDataFetch: [{ qWidth: 3, qHeight: 3300 }],
            qSuppressZero: true,
            qSuppressMissing: true,
            qStateName: 'Stacked',
          },
          showTitles: true,
          title: '',
          subtitle: '',
          footnote: '',
        },
        data: {
          targets: [
            {
              path: '/qHyperCubeDef',
              dimensions: {
                min: 1,
                max: 2,
              },
              measures: {
                min: 1,
                max: 1,
              },
            },
          ],
        },
      },
      component() {
        const element = useElement();
        const layout = useStaleLayout();
        const rect = useRect();
        const model = useModel();

        const [instance, setInstance] = useState();

        useEffect(() => {
          const p = picasso.chart({
            element,
            data: [],
            settings: {},
          });

          setInstance(p);

          return () => {
            p.destroy();
          };
        }, []);

        useEffect(() => {
          if (!instance) {
            return;
          }

          // Selected Race
          // const selectedRace = layout.qHyperCube.qDataPages[0].qMatrix.filter((row) => row[0].qState === 'S').map((row) => row[0].qText);

          const isCountry = layout.qHyperCube.qDimensionInfo[1].qFallbackTitle === 'Respondent Country';

          const doPercent = layout.qHyperCube.qMeasureInfo[0].qFallbackTitle !== 'Count(Distinct respid)';

          const colorScale = d3.scaleOrdinal()
          .domain(['United States', 'United Kingdom', 'Australia', 'France', 'Germany', 'Japan'])
          .range(['#655dc6',
          '#1c355e',
          '#006580',
          '#009845',
          '#870064',
          '#27b9ed',
          '#244b5a']);

          // const labels = ({
          //   c,
          //   justify = 0,
          //   align = 0.5,
          //   position = 'inside',
          //   fontSize = 11,
          //   fill = '#FFF',
          // }) => ({
          //   type: 'labels',
          //   displayOrder: 2,
          //   settings: {
          //     sources: [{
          //       component: c,
          //       selector: 'rect',
          //       strategy: {
          //         type: 'bar',
          //         settings: {
          //           direction: 'left',
          //           fontSize,
          //           align,
          //           labels: [{
          //             placements: [{
          //               position,
          //               fill,
          //               justify,
          //             }],
          //             label: function label(d) {
          //               return numeral(d.data.end.value).format('0.0%');
          //             },
          //           }],
          //         },
          //       },
          //     }],
          //   },
          // });

          // const labelsToShow = isCountry ? {
          //   type: 'labels',
          //   displayOrder: 2,
          //   settings: {
          //     sources: [{
          //       component: 'bars',
          //       selector: 'rect',
          //       strategy: {
          //         type: 'bar',
          //         settings: {
          //           direction: 'right',
          //           labels: [{
          //             placements: [{
          //               position: 'outside',
          //             }],
          //             label: (node) => numeral(node.data.end.value).format('0.0%'),
          //           }],
          //           fontSize: 11,
          //         },
          //       },
          //     }],
          //   },
          // } : labels({ c: 'bars' });

          instance.update({
            data: [
              {
                type: 'q',
                key: 'qHyperCube',
                data: layout.qHyperCube,
              },
            ],
            settings: {
              formatters: {
                percent: {
                  formatter: 'd3',
                  type: 'number',
                  format: ',.0%',
                },
              },
              collections: [
                {
                  key: 'stacked',
                  data: {
                    extract: {
                      field: 'qDimensionInfo/0',
                      props: {
                        series: {
                          field: 'qDimensionInfo/1',
                        },
                        end: {
                          field: 'qMeasureInfo/0',
                        },
                      },
                    },
                    stack: {
                      stackKey: (d) => d.value,
                      value: (d) => d.end.value,
                    },
                  },
                },
              ],
              scales: {
                y: {
                  data: {
                    collection: {
                      key: 'stacked',
                    },
                  },
                  invert: false,
                  expand: 0.15,
                  min: 0,
                  // max: 1,
                  forceBounds: true,
                },
                x: {
                  data: {
                    extract: {
                      field: 'qDimensionInfo/0',
                    },
                  },
                  invert: true,
                  paddingInner: 0.06,
                },
                color: {
                  data: {
                    extract: {
                      field: 'qDimensionInfo/1',
                    },
                  },
                  range: ['#655dc6',
                  '#1c355e',
                  '#006580',
                  '#009845',
                  '#870064',
                  '#27b9ed',
                  '#244b5a'],
                  type: 'categorical-color',
                },
              },
              components: [
                {
                  type: 'axis',
                  dock: 'left',
                  scale: 'x',
                  settings: {
                    labels: {
                      show: true,
                      fontSize: 10.5,
                    },
                  },
                },
                {
                  type: 'axis',
                  dock: 'bottom',
                  scale: 'y',
                  formatter: doPercent ? 'percent' : '',
                },
                {
                  key: 'bars',
                  type: 'box',
                  data: {
                    collection: 'stacked',
                  },
                  settings: {
                    orientation: 'horizontal',
                    major: { scale: 'x' },
                    minor: { scale: 'y', ref: 'end' },
                    box: {
                      fill: isCountry ? ((d) => colorScale(d.datum.series.label)) : { scale: 'color', ref: 'series' },
                    },
                  },
                },
                {
                  type: 'legend-cat',
                  key: 'legend',
                  dock: 'bottom',
                  scale: isCountry ? {
                    data: ['United States', 'United Kingdom', 'Australia', 'France', 'Germany', 'Japan'],
                    range: ['#655dc6',
                    '#1c355e',
                    '#006580',
                    '#009845',
                    '#870064',
                    '#27b9ed',
                    '#244b5a'],
                    type: 'categorical-color',
                  } : 'color',
                  settings: {
                    title: {
                      show: false,
                    },
                    layout: {
                      size: 2,
                    },
                    fontSize: 9,
                  },
                },
                {
                  type: 'grid-line',
                  x: {
                    scale: 'y',
                  },
                  ticks: {
                    show: true,
                    stroke: '#70707030',
                    strokeWidth: 1,
                    // strokeDasharray: '3, 3',
                  },
                 },
                // ...!isCountry ? labels({ c: 'bars' }) : {},
                // ...labelsToShow,
                // {
                //   type: 'labels',
                //   displayOrder: 2,
                //   settings: {
                //     sources: [{
                //       component: 'bars',
                //       selector: 'rect',
                //       strategy: {
                //         type: 'bar',
                //         settings: {
                //           direction: 'right',
                //           labels: [{
                //             placements: [{
                //               position: 'outside',
                //             }],
                //             label: (node) => numeral(node.data.end.value).format('0.0%'),
                //           }],
                //           fontSize: 11,
                //         },
                //       },
                //     }],
                //   },
                // },
                ...isCountry ? [{
                  type: 'labels',
                  displayOrder: 2,
                  settings: {
                    sources: [{
                      component: 'bars',
                      selector: 'rect',
                      strategy: {
                        type: 'bar',
                        settings: {
                          direction: 'right',
                          labels: [{
                            placements: [{
                              position: 'outside',
                            }],
                            label: (node) => (doPercent ? numeral(node.data.end.value).format('0.0%') : node.data.end.value),
                          }],
                          fontSize: 11,
                        },
                      },
                    }],
                  },
                }] : [{
                  type: 'labels',
                  displayOrder: 2,
                  settings: {
                    sources: [{
                      component: 'bars',
                      selector: 'rect',
                      strategy: {
                        type: 'bar',
                        settings: {
                          direction: 'left',
                          fontSize: 9,
                          // align: 0.5,
                          labels: [{
                            placements: [{
                              position: 'inside',
                              fill: '#FFFFFF',
                              justify: 0,
                            }],
                            label: (d) => (doPercent ? numeral(d.data.end.value - d.data.start.value).format('0.0%') : (d.data.end.value - d.data.start.value)),
                          }],
                        },
                      },
                    }],
                  },
                }],
                {
                  key: 'tooltip',
                  type: 'tooltip',
                  displayOrder: 10,
                  settings: {
                    duration: 8000,
                    // Target point marker
                    filter: (nodes) => nodes.filter((node) => node.type === 'container' && node.key === 'bars'),
                    // Extract data
                    extract: ({ node }) => {
                      const obj = {};
                      obj.dim1 = node.data.label;
                      obj.dim2 = node.data.series.label;
                      obj.measEnd = node.data.end.value;
                      obj.measStart = node.data.start.value;
                      return obj;
                    },
                    content: ({ h, data }) => { // eslint-disable-line no-shadow
                      const els = [];

                      data.forEach((node) => {
                        const eltitle = h('div', {
                          style: {
                            padding: '10px 4px', textAlign: 'left',
                          },
                        }, [h('span', {
                          style: {
                            color: '#FFFFFF', textTransform: 'Capitalize', fontWeight: 600,
                          },
                        }, node.dim1)]);

                        const el1 = h('td', { style: { padding: '4px' } }, `${node.dim2}: `);
                        const el2 = h('td', { style: { padding: '4px' } }, doPercent ? numeral(node.measEnd - node.measStart).format('0.0%') : (node.measEnd - node.measStart));

                        const elr1 = h('tr', { style: { padding: '4px' } }, [el1, el2]);

                        els.push(eltitle, elr1);
                      });
                      return h('div', { style: { padding: 5, zIndex: 99999 } }, els);
                    },
                    placement: {
                      type: 'pointer',
                      area: 'target',
                      dock: 'auto',
                    },
                  },
                },
              ],
              interactions: [
                {
                type: 'native',
                events: {
                  mousemove(e) {
                    this.chart.component('tooltip').emit('show', e);
                  },
                  mouseleave() {
                    this.chart.component('tooltip').emit('hide');
                  },
                },
              },
              {
                type: 'hammer',
                gestures: [
                  {
                    type: 'Tap',
                    events: {
                      tap(e) {
                        const chartBounds = element.getBoundingClientRect();
                        const cx = e.center.x - chartBounds.left;
                        const cy = e.center.y - chartBounds.top;
                        const shapes = this.chart.shapesAt({ x: cx, y: cy });
                        const values = shapes.map((shape) => shape.data.value);
                        model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                      },
                    },
                  },
                ],
              },
                // {
                //   type: 'native',
                //   events: {
                //     // click(e) {
                //     //   const chartBounds = element.getBoundingClientRect();
                //     //   const cx = e.clientX - chartBounds.left;
                //     //   const cy = e.clientY - chartBounds.top;
                //     //   const shapes = this.chart.shapesAt({ x: cx, y: cy });
                //     //   const values = shapes.map((shape) => shape.data.value);
                //     //   model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                //     // },
                //   },
                // },
                // {
                //   type: 'hammer',
                //   gestures: [
                //     {
                //       type: 'Tap',
                //       events: {
                //         tap(e) {
                //           const chartBounds = element.getBoundingClientRect();
                //           const cx = e.center.x - chartBounds.left;
                //           const cy = e.center.y - chartBounds.top;
                //           const shapes = this.chart.shapesAt({ x: cx, y: cy });
                //           const values = shapes.map((shape) => shape.data.value);
                //           model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                //         },
                //       },
                //     },
                //   ],
                // },
              ],
            },
          });
          // const items = document.querySelectorAll('button[data-component-key]');

          // // eslint-disable-next-line no-plusplus
          // for (let index = 0; index < items.length; index++) {
          //   if ('ontouchstart' in document.documentElement === true) {
          //     // items[index].addEventListener('touchstart', (e) => {
          //     //   e.preventDefault();
          //     //   instance.component(e.target.getAttribute('data-component-key')).emit(e.target.getAttribute('data-action'));
          //     // });
          //     console.log('IFFF');
          //   } else {
          //     // items[index].addEventListener('click', (e) => {
          //     //   e.preventDefault();
          //     //   instance.component(e.target.getAttribute('data-component-key')).emit(e.target.getAttribute('data-action'));
          //     // });
          //     console.log('EKSEEE');
          //   }
          // }
        }, [layout, instance]);

        useEffect(() => {
          if (!instance) {
            return;
          }
          instance.update();
        }, [rect.width, rect.height, instance]);
      },
    };
  }
